export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';


export const AUTH_FORGET_PASSWORD_REQUEST = 'AUTH_FORGET_PASSWORD_REQUEST';
export const AUTH_FORGET_PASSWORD_SUCCESS = 'AUTH_FORGET_PASSWORD_SUCCESS';
export const AUTH_FORGET_PASSWORD_ERROR = 'AUTH_FORGET_PASSWORD_ERROR';
